import React from "react";
import { PanelSectionTitle } from "../../layout/StyledComponents/StyledComponents";
import ProductDataList from "../ProductDataList/ProductDataList";
const RCPROInfos = () => {
  return (
    <div>
      <PanelSectionTitle>Responsabilité Civile Pro</PanelSectionTitle>
      <ProductDataList />
    </div>
  );
};

export default RCPROInfos;
